export const iconCss = {
  path: {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5,
  },
};
